import { render, staticRenderFns } from "./MachineryAtlasEditLayer.vue?vue&type=template&id=2f79e628&scoped=true&"
import script from "./MachineryAtlasEditLayer.vue?vue&type=script&lang=js&"
export * from "./MachineryAtlasEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./MachineryAtlasEditLayer.vue?vue&type=style&index=0&id=2f79e628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f79e628",
  null
  
)

export default component.exports